import { useAuthStore } from '@/stores/auth'
import BaseMiddleware from './BaseMiddleware'

export default class Permission extends BaseMiddleware {
    handle(request, next) {
        useAuthStore().load(false).then((user) => {
            user.can(this.parameters) ? next(request) : request.router.next('/403')
        }).catch((e) => {
            console.warn(e)
            request.router.next('/403')
        })
    }
}
